module.exports = __webpack_public_path__ + "static/media/2018_conf_Shipping_Product_at_Scale.abdee465.png";